import React, { useState, memo } from "react";
import ReactMarkdown from 'react-markdown';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Button } from './ui/button';

function DawidDisclaimer({ disclaimer }) {
  const [open, setOpen] = useState(true);
  const { title, body } = disclaimer;

  return (
    <Dialog open={open}>
      <DialogContent showClose={false} className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="space-y-3" asChild>
          <div>
            {body.map((paragraph, index) => (
              <ReactMarkdown key={index}>{paragraph}</ReactMarkdown>
            ))}
            <div className="text-center mt-6">
              <Button
                id="acknowledge-disclaimer"
                onClick={() => setOpen(false)}
                tabIndex={1}
              >
                I acknowledge that I have carefully read the disclaimer hereabove and agree to all the terms of use under which DAWID is operating.
              </Button>
            </div>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}

export default memo(DawidDisclaimer, (prev, next) => prev.disclaimer === next.disclaimer);
